import { FC, ReactNode } from 'react'
import clsx from 'clsx'

import AnimationWrap from 'containers/animation-wrap/animation-wrap'
import SidebarTop from './sidebar-top'
import useNavbarHeight from 'store/navbar/useNavbarHeight'

import { animationType } from 'containers/animation-wrap/data'

import styles from './sidebar.module.scss'

interface ISidebar {
  isActive: boolean
  children: ReactNode
  title?: string
  modificator?: string
  iconData: any
  setDates?: (dates: Date[]) => void
  btnBackHandler?: () => void
}

const Sidebar: FC<ISidebar> = ({
  children,
  isActive,
  title,
  modificator = '',
  ...props
}: ISidebar) => {
  const { navbarHeight } = useNavbarHeight()

  return (
    <AnimationWrap animationType={animationType.SIDEBAR} opened={isActive}>
      <aside
        style={{ top: `${navbarHeight}px` }}
        className={clsx(styles.sidebar, {
          [modificator]: modificator,
        })}
      >
        {title && <SidebarTop {...props} title={title} />}
        {children}
      </aside>
    </AnimationWrap>
  )
}

export default Sidebar
